import { ErrorMessageConfig } from '@config/error-message.config';

export const ErrorHandler = (error: unknown): void => {
	const errorMessage = ErrorMessageConfig.NETWORK_ERROR;
	if (error instanceof Error) {
		throw error.message;
	}
	throw errorMessage;
};
